exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fa-pie-chart[data-v-36a0061c]{position:relative;display:flex;flex-direction:column;align-items:center}.chart-label[data-v-36a0061c]{margin-top:8px;font-size:12px;font-weight:600;color:#666;text-transform:uppercase;letter-spacing:.5px}", ""]);

// exports
